// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISortCriteriaClaimSortedFieldsType
 */
export interface ISortCriteriaClaimSortedFieldsType {
    /**
     * 
     * @type {string}
     * @memberof ISortCriteriaClaimSortedFieldsType
     */
    field?: ISortCriteriaClaimSortedFieldsTypeFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof ISortCriteriaClaimSortedFieldsType
     */
    direct?: ISortCriteriaClaimSortedFieldsTypeDirectEnum;
}

/**
* @export
* @enum {string}
*/
export enum ISortCriteriaClaimSortedFieldsTypeFieldEnum {
    ID = 'ID',
    CATEGORY = 'CATEGORY',
    STATUS = 'STATUS',
    CREATED_AT = 'CREATED_AT',
    APPEAL_DATE = 'APPEAL_DATE'
}
/**
* @export
* @enum {string}
*/
export enum ISortCriteriaClaimSortedFieldsTypeDirectEnum {
    DESC = 'DESC',
    ASC = 'ASC'
}


/**
 * Check if a given object implements the ISortCriteriaClaimSortedFieldsType interface.
 */
export function instanceOfISortCriteriaClaimSortedFieldsType(value: object): value is ISortCriteriaClaimSortedFieldsType {
    return true;
}

export function ISortCriteriaClaimSortedFieldsTypeFromJSON(json: any): ISortCriteriaClaimSortedFieldsType {
    return ISortCriteriaClaimSortedFieldsTypeFromJSONTyped(json, false);
}

export function ISortCriteriaClaimSortedFieldsTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISortCriteriaClaimSortedFieldsType {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'] == null ? undefined : json['field'],
        'direct': json['direct'] == null ? undefined : json['direct'],
    };
}

export function ISortCriteriaClaimSortedFieldsTypeToJSON(json: any): ISortCriteriaClaimSortedFieldsType {
    return ISortCriteriaClaimSortedFieldsTypeToJSONTyped(json, false);
}

export function ISortCriteriaClaimSortedFieldsTypeToJSONTyped(value?: ISortCriteriaClaimSortedFieldsType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'direct': value['direct'],
    };
}

